import React from 'react';
import Icon from 'material-ui/svg-icons/social/person-add';

export default class PersonAddIcon extends React.PureComponent {
  render() {
    return <Icon className="icon person-add" onClick={this.props.onClick} />;
  }
}
